import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'BaseTextarea' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: { type: String, default: '' },
  label: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  rows: { type: Number, default: 3 },
  maxlength: { type: Number, default: 500 },
  showWordLimit: { type: Boolean, default: true },
  disabled: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  error: { type: String, default: '' }
},
  emits: ["input"],
  setup(__props, { emit }: { emit: ({ (e: 'input', value: string): void }), expose: any, slots: any, attrs: any }) {

// Themed multi-line text input that matches base-input's look (transparent
// background, same border as .form-control, primary focus ring) with light and
// dark parity. Use for any capped free-text field instead of a bare el-input
// textarea plus a per-page style block.




function onInput(val: string) {
  emit('input', val)
}

return { __sfc: true,emit, onInput }
}

})